module.exports = __webpack_public_path__ + "static/img/p_1_3.ec22388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p_1_3.jpg
// module id = Ckcg
// module chunks = 1